module.exports = __webpack_public_path__ + "static/media/logo-baixagrande.ae650d52.png";